import { faDatabase, faLayerGroup, faServer, faUsers } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Breadcrumb } from "../components/ui";
import { UserAuth } from "../context/AuthContext";

const adminSections = [
  {
    to: "/admin/users",
    label: "Users",
    icon: faUsers,
    description: "Manage user accounts",
  },
  {
    to: "/admin/processes",
    label: "Processes",
    icon: faLayerGroup,
    description: "Name generation processes",
  },
  {
    to: "/admin/infrastructure",
    label: "Infrastructure",
    icon: faServer,
    description: "System health & services",
  },
  {
    to: "/admin/data-sources",
    label: "Data Sources",
    icon: faDatabase,
    description: "External APIs & sources",
  },
];

const AdminTile = ({ section }) => (
  <Link to={section.to} className="block h-full">
    <div className="bg-base-100 rounded-lg p-6 border border-base-content/10 hover:border-base-content/30 h-full flex flex-col items-center justify-center min-h-[160px] gap-4 transition-colors">
      <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center">
        <FontAwesomeIcon icon={section.icon} className="text-primary text-xl" />
      </div>
      <div className="text-center">
        <span className="font-[Oswald] font-semibold uppercase tracking-tight -skew-x-6 text-[#555] text-lg block">
          {section.label}
        </span>
        <span className="text-xs text-base-content/50 mt-1 block">{section.description}</span>
      </div>
    </div>
  </Link>
);

function Admin() {
  const { user } = UserAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user === null) {
      navigate("/signin");
    }
  }, [user, navigate]);

  if (!user?.email) {
    return null;
  }

  return (
    <div className="container mx-auto px-4 py-6">
      <Breadcrumb
        items={[
          { label: "Home", href: "/" },
          { label: "Admin" },
        ]}
        className="mb-4"
      />

      {/* Header Card */}
      <div className="bg-base-100 rounded-lg p-4 sm:p-5 mb-6 border border-base-content/10">
        <h1 className="text-2xl font-semibold text-base-content">Admin</h1>
        <p className="text-sm text-base-content/50 mt-1">Manage users, processes, infrastructure, and data sources</p>
      </div>

      {/* Admin Sections Grid */}
      <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {adminSections.map(section => (
          <AdminTile key={section.to} section={section} />
        ))}
      </div>
    </div>
  );
}

export default Admin;
